import { render, staticRenderFns } from "./HeaderSection.vue?vue&type=template&id=22ae8c3e&scoped=true&"
import script from "./HeaderSection.vue?vue&type=script&lang=js&"
export * from "./HeaderSection.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSection.vue?vue&type=style&index=0&id=22ae8c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ae8c3e",
  null
  
)

export default component.exports